import React from 'react';

const AssetOverviewTab = ({ currentAsset }) => {
  if (!currentAsset) return null;

  return (
    <div className="space-y-6">
      {/* Basic Info */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <div className="w-[5px] h-6 bg-purple-600 rounded mr-3"></div>
          Asset Configuration
        </h3>
        <div className="grid grid-cols-3 gap-6 ml-1">
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Asset Name</p>
            <p className="text-base font-medium text-gray-900 break-words">{currentAsset.Configuration.assetName || 'N/A'}</p>
          </div>
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Data Asset Owner</p>
            <p className="text-base text-gray-900 break-words">{currentAsset.Configuration.dataAssetOwner || 'N/A'}</p>
          </div>
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Technical Data Steward</p>
            <p className="text-base text-gray-900 break-words">{currentAsset.Configuration.technicalDataSteward || 'N/A'}</p>
          </div>
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Region</p>
            <p className="text-base text-gray-900 break-words">{currentAsset.Configuration.region || 'N/A'}</p>
          </div>
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Market</p>
            <p className="text-base text-gray-900 break-words">{currentAsset.Configuration.market || 'N/A'}</p>
          </div>
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Dataframe Name</p>
            <p className="text-base text-gray-900 font-mono text-sm break-all">{currentAsset.Configuration.dataframeName || 'N/A'}</p>
          </div>
          <div className="min-w-0">
            <p className="text-sm text-gray-500 mb-1">Sample Size</p>
            <p className="text-base text-gray-900 break-words">{currentAsset.Configuration.sampleSize || 'N/A'}</p>
          </div>
        </div>
        

        {/* Tags */}
        {currentAsset.Configuration.tags && currentAsset.Configuration.tags.length > 0 && (
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-2">Tags</p>
            <div className="flex flex-wrap gap-2">
              {currentAsset.Configuration.tags.map((tag, idx) => (
                <span key={idx} className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Data Quality Metrics */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <div className="w-[5px] h-6 bg-fuchsia-500 rounded mr-3"></div>
          Data Quality Metrics
        </h3>
        <div className="grid grid-cols-6 gap-4">
          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">Completeness</p>
            <p className={`text-xl font-bold ${currentAsset.Configuration.completeness !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {currentAsset.Configuration.completeness !== null ? `${currentAsset.Configuration.completeness}%` : 'N/A'}
            </p>
          </div>
          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">Accuracy</p>
            <p className={`text-xl font-bold ${currentAsset.Configuration.accuracy !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {currentAsset.Configuration.accuracy !== null ? `${currentAsset.Configuration.accuracy}%` : 'N/A'}
            </p>
          </div>
          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">Consistency</p>
            <p className={`text-xl font-bold ${currentAsset.Configuration.consistency !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {currentAsset.Configuration.consistency !== null ? `${currentAsset.Configuration.consistency}%` : 'N/A'}
            </p>
          </div>

          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">Freshness</p>
            <p className={`text-xl font-bold ${currentAsset.Configuration.freshness !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {currentAsset.Configuration.freshness !== null ? `${currentAsset.Configuration.freshness}%` : 'N/A'}
            </p>
          </div>
          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">Uniqueness</p>
            <p className={`text-xl font-bold ${currentAsset.Configuration.uniqueness !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {currentAsset.Configuration.uniqueness !== null ? `${currentAsset.Configuration.uniqueness}%` : 'N/A'}
            </p>
          </div>
          <div className="text-center p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-500 mb-1">Validity</p>
            <p className={`text-xl font-bold ${currentAsset.Configuration.validity !== null ? 'text-green-600' : 'text-gray-400'}`}>
              {currentAsset.Configuration.validity !== null ? `${currentAsset.Configuration.validity}%` : 'N/A'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetOverviewTab;
